import {
  MOBILE_MENU_OPEN,
  MOBILE_MENU_CLOSE,
  useMobileMenuDispatch,
  useMobileMenuState,
} from "./MobileMenuContext";

export function useMobileMenu() {
  const dispatch = useMobileMenuDispatch();

  const { isOpen } = useMobileMenuState();

  const openMobileMenu = () => {
    dispatch({ type: MOBILE_MENU_OPEN });
  };

  const closeMobileMenu = () => {
    dispatch({ type: MOBILE_MENU_CLOSE });
  };

  return { openMobileMenu, closeMobileMenu, isMobileMenuOpen: isOpen };
}

export default useMobileMenu;
